export class TruckOverviewFilterModel {
    filterText = '';
}
